<template>
  <div
    class="mx-2 pb-1 d-flex flex-column"
    :class="screenType !== 'desktop' && uploadStep === 4 && 'remaining-space-hidden'"
  >
    <StepForMobile
      :currentStep="4"
      :screenType="screenType"
      :title="this.$t('Results')"
    />
    <div v-if="screenType !== 'desktop' && uploadStep === 4" :class="screenType !== 'desktop' && 'remaining-space-hidden'">
      <div :class="[screenType !== 'desktop' && 'single-step-wrapper-mobile h-100-per overflow-auto']">
        <div class="overflow-auto">
          <ReportCard
            :restartSessionClicked="restartSessionClicked"
            :statusResults="statusResults"
            :screenType="screenType"
          />
        </div>
      </div>
    </div>
    <StartRestartButtons
      v-if="screenType !== 'desktop' && uploadStep === 4"
      :session="session"
      :filteringErrMessage="filteringErrMessage"
      :setIsShowFilteringErrMessage="v => (isShowFilteringErrMessage = v)"
      :startFilteringClicked="startFilteringClicked"
      :restartSessionClicked="restartSessionClicked"
      :setIsShowUploadingDetails="v => (isShowUploadingDetails = v)"
      :buttonText="$t('Continue')"
      :screenType="screenType"
    />
  </div>
</template>

<script>
import StartRestartButtons from '@/components/WebsiteInterface/WebsiteInterfaceDesktop/Childern/UploadDesktop/Children/UploadingDetails/Children/StartRestartButtons/StartRestartButtons.vue'
import StepForMobile from '@/components/WebsiteInterface/CommonComponents/StepForMobile.vue'
import ReportCard from '@/components/WebsiteInterface/CommonComponents/UploadReportDialog/Children/ReportCard.vue'
export default {
  name: 'Results',
  props: {
    restartSessionClicked: Function,
    statusResults: Object,
    screenType: String,
    uploadStep: Number,
    session: Object,
    filteringErrMessage: String,
    startFilteringClicked: Function,
    isShowFilteringErrMessage: Boolean,
    isShowUploadingDetails: Boolean,
    setIsShowFilteringErrMessage: Function,
    setIsShowUploadingDetails: Function,
  },
  components: {
    StepForMobile,
    ReportCard,
    StartRestartButtons,
  },
}
</script>
